import React, { Component } from 'react';
import cn from 'classnames';

export default class EditableSqlReportRow extends Component {
  state = {
    isEdit: false,
    value: this.props.value,
  };

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  handleChangeInput = (e) => {
    this.setState({ value: e.target.value });
  };

  handleChangeSelect = (e) => {
    this.setState({ value: e.target.value === 'true' });
  };

  startEdit = () => {
    this.setState({ isEdit: true });
  };

  cancelEdit = () => {
    this.setState({ value: this.props.value, isEdit: false });
  };

  handleSave = () => {
    this.props.save(this.props.name, this.state.value);
    this.cancelEdit();
  };

  render() {
    const { value, isEdit } = this.state;
    const { label, type, editTooltip } = this.props;
    if (isEdit) {
      return (
        <tr>
          <th>{label}</th>
          <td>
            {type === 'input' ? (
              <React.Fragment>
                <input
                  className="form-control"
                  value={value}
                  onChange={this.handleChangeInput}
                />
                {editTooltip && (
                  <span style={{ fontSize: '12px' }}>{editTooltip}</span>
                )}
              </React.Fragment>
            ) : (
              <select
                style={{ maxWidth: '200px' }}
                className="form-control"
                value={value ? 'true' : 'false'}
                onChange={this.handleChangeSelect}
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            )}
          </td>
          <td
            className={cn({ 'va-top': editTooltip })}
            style={{
              minWidth: '167px',
              width: '167px',
            }}
          >
            <button onClick={this.handleSave} className="btn btn-primary mar-r">
              Save
            </button>
            <button onClick={this.cancelEdit} className="btn btn-default">
              Cancel
            </button>
          </td>
        </tr>
      );
    }

    return (
      <tr>
        <th>{label}</th>
        <td>
          {type === 'input'
            ? this.props.value
            : this.props.value
              ? 'Yes'
              : 'No'}
        </td>
        <td
          style={{
            textAlign: 'right',
            minWidth: '167px',
            width: '167px',
            height: editTooltip ? '71px' : '',
          }}
        >
          <img
            style={{ cursor: 'pointer', width: '16px', height: '16px' }}
            onClick={this.startEdit}
            src="/images/pen-to-square-regular.svg"
            alt="edit"
          />
        </td>
      </tr>
    );
  }
}
